import {
  Box,
  FloraSelect,
  FloraSelectItem,
  FloraSwitch,
  Flex,
  Grid,
  FloraInput,
  FloraTypography
} from '@grupoboticario/flora-react'

import { benefitsEventsFilter } from '@/utils/filterSchemas/benefitsEventsFilter'

import * as S from './LocationSection.styles'

const LocationSection = ({ values, setFieldValue }) => {
  const regionOptions = benefitsEventsFilter[0].filters.find((f) => f.key === 'region').options

  const handleRemoteEventToggle = () => {
    const newValue = !values.isRemoteEvent
    setFieldValue('isRemoteEvent', newValue)

    if (newValue) {
      setFieldValue('address', '')
      setFieldValue('city', 'Brasil')
      setFieldValue('state', 'BR')
    }
  }

  const isLocationDisabled = values.isRemoteEvent
  const isLocationRequired = !values.isRemoteEvent

  return (
    <Box css={S.sectionBoxCss}>
      <FloraTypography css={S.sectionTitleCss} fontSize="bodyLargeStandard" fontWeight="medium">
        Localização
      </FloraTypography>

      <Grid css={S.locationGridCss}>
        <FloraInput
          disabled={isLocationDisabled}
          id="endereco"
          label="Endereço:"
          onChange={(e) => setFieldValue('address', e.target.value)}
          required={isLocationRequired}
          size="medium"
          value={values.address || ''}
        />
        <FloraInput
          disabled={isLocationDisabled}
          id="cidade"
          label="Cidade:"
          onChange={(e) => setFieldValue('city', e.target.value)}
          required={isLocationRequired}
          size="medium"
          value={values.city || ''}
        />
        <FloraSelect
          disabled={isLocationDisabled}
          id="uf"
          label="UF:"
          onSelected={(selected) => setFieldValue('state', selected?.value ?? '')}
          placeholder="Selecionar estado"
          required={isLocationRequired}
          size="medium"
          value={values.state || ''}
        >
          {regionOptions.map(({ value, label }) => (
            <FloraSelectItem key={value} label={label} value={value} />
          ))}
        </FloraSelect>
      </Grid>

      <Flex align="center" css={S.remoteToggleRowCss} gap="$2">
        <FloraSwitch
          checked={values.isRemoteEvent || false}
          id="remote-event-toggle"
          onChange={handleRemoteEventToggle}
        />
        <FloraTypography fontSize="bodyLargeStandard">Evento Remoto</FloraTypography>
      </Flex>
    </Box>
  )
}

export default LocationSection
